import { formatAmount } from './formatAmount';

export const calculateVaFundingFee = (loanAmount: number, percentage: number): number => {
  const formatedAmount = formatAmount(loanAmount * (percentage / 100))

  return parseFloat(formatedAmount)
}
